import React from 'react';
import styles from './Accordion.module.scss';

interface AccordionProps {
  title: string;
  theme: 'blue' | 'green';
  content: string;
  isOpen: boolean;       // Получаем состояние снаружи
  onToggle: () => void;  // Получаем функцию переключения снаружи
}

export const Accordion: React.FC<AccordionProps> = ({ title, theme, content, isOpen, onToggle }) => {
  return (
    <div className={`${styles.accordionWrapper} ${styles[theme]}`}>
      <button 
        className={`${styles.accordionHeader} ${isOpen ? styles.openHeader : ''}`} 
        onClick={onToggle} // Вызываем переданную функцию при клике
        aria-expanded={isOpen}
      >
        <span className={styles.title}>{title}</span>
        <svg 
          className={`${styles.chevron} ${isOpen ? styles.open : ''}`} 
          width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L7 7L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      
      <div className={`${styles.accordionContent} ${isOpen ? styles.openContent : ''}`}>
        <div className={styles.contentInner}>
          {content}
        </div>
      </div>
    </div>
  );
};